module.exports = __webpack_public_path__ + "static/img/img53.72ec2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img53.png
// module id = 9aNa
// module chunks = 1